import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Box } from '@material-ui/core';

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function getWeeksAgo(dateString) {
  if (!dateString) return null;
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  return diffMs / (1000 * 60 * 60 * 24 * 7);
}

function getHistogramData(data, numBins = 20) {
  const ages = data
    .map(row => getWeeksAgo(row.last_collected_date))
    .filter(age => age !== null && !isNaN(age));
  if (ages.length === 0) return { bins: [], counts: [] };
  const min = Math.min(...ages);
  const max = Math.max(...ages);
  const binWidth = (max - min) / numBins;
  const bins = Array.from({ length: numBins }, (_, i) => min + i * binWidth);
  const counts = Array(numBins).fill(0);
  ages.forEach(age => {
    let bin = Math.floor((age - min) / binWidth);
    if (bin === numBins) bin = numBins - 1; // Edge case for max value
    counts[bin]++;
  });
  // Bin labels as ranges
  const binLabels = bins.map((b, i) => {
    const end = i === bins.length - 1 ? max : bins[i + 1];
    return `${Math.round(b)}-${Math.round(end)}`;
  });
  return { bins: binLabels, counts };
}

export default function CompanyDataAgeHistogram({ outOfDateProducts }) {
  const { bins, counts } = getHistogramData(outOfDateProducts || [], 20);

  const chartData = {
    labels: bins,
    datasets: [
      {
        label: 'Product count',
        data: counts,
        backgroundColor: '#9C27B0',
        borderRadius: 2,
        barPercentage: 1.0,
        categoryPercentage: 1.0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: 'Distribution of Data Age (weeks)',
        font: { size: 22 },
      },
      tooltip: { enabled: true },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Age (weeks)',
          font: { size: 16 },
        },
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Product count',
          font: { size: 16 },
        },
        grid: { color: '#eee' },
      },
    },
  };

  return (
    <Box sx={{ height: 'calc(100vh - 200px)', minHeight: '400px', maxHeight: '600px' }}>
      <Bar data={chartData} options={options} />
    </Box>
  );
} 